import React from "react";
import { useHistory } from "react-router-dom";
import {
  Box,
  Container,
  Typography,
  Grid,
  Button,
  Divider,
} from "@mui/material";
import { VideoCall } from "@mui/icons-material";
import { ROUTES } from "../../routes/User/paths";
import "./PublicFooter.css";

const PublicFooter = () => {
  const history = useHistory();

  const footerSections = [
    {
      title: "Product",
      links: [
        {
          label: "Features",
          onClick: () =>
            document
              .getElementById("features")
              ?.scrollIntoView({ behavior: "smooth" }),
        },
        {
          label: "Pricing",
          onClick: () =>
            document
              .getElementById("pricing")
              ?.scrollIntoView({ behavior: "smooth" }),
        },
      ],
    },
    {
      title: "Company",
      links: [
        { label: "About", onClick: () => history.push(ROUTES.about) },
        { label: "Contact", onClick: () => {} },
      ],
    },
    {
      title: "Legal",
      links: [
        { label: "Privacy", onClick: () => {} },
        { label: "Terms", onClick: () => {} },
      ],
    },
  ];

  return (
    <Box className="public-footer">
      <Container maxWidth="lg">
        {/* Main Footer Content */}
        <Grid container spacing={6}>
          {/* Brand Column */}
          <Grid item xs={12} md={4}>
            <Box className="footer-brand-section">
              <Box
                className="footer-logo"
                onClick={() => history.push(ROUTES.landing)}
              >
                <Box className="footer-logo-icon">
                  <VideoCall sx={{ fontSize: 28 }} />
                </Box>
                <Typography variant="h6" className="footer-logo-text">
                  IOTA
                </Typography>
              </Box>
              <Typography variant="body2" className="footer-tagline">
                Connecting creators worldwide through live video experiences.
              </Typography>
            </Box>
          </Grid>

          {/* Links Columns */}
          {footerSections.map((section, index) => (
            <Grid item xs={6} sm={4} md={2} key={index}>
              <Typography variant="subtitle1" className="footer-heading">
                {section.title}
              </Typography>
              <Box className="footer-links">
                {section.links.map((link, idx) => (
                  <Button
                    key={idx}
                    onClick={link.onClick}
                    className="footer-link"
                  >
                    {link.label}
                  </Button>
                ))}
              </Box>
            </Grid>
          ))}
        </Grid>

        {/* Footer Bottom */}
        <Box className="footer-bottom">
          <Typography variant="body2" className="footer-copyright">
            © {new Date().getFullYear()} IOTA Platform. All rights reserved.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default PublicFooter;
